module.exports = __webpack_public_path__ + "static/media/i-mobile.8454cec6.png";